import MirrorManager from "../mirror/mirror-manager";
import AnywhereManager from '../anywhere/anywhere-manager';
import PresenterManager from '../presenter/presenter-manager';

function setupEngine(product, role, name, publicKey, roomKey) {
  if (typeof (role) === 'undefined') return;

  let manager;
  if (product === 'anywhere') {
    manager = new AnywhereManager(role, name, publicKey, roomKey);
  }
  if (product === 'mirror_shoot') {
    manager = new MirrorManager(role, name, publicKey, roomKey);
  }
  if (product === 'presenter') {
    manager = new PresenterManager(role, name, publicKey, roomKey);
  }
  window.manager = manager;
}

window.setupEngine = setupEngine;
